import { render, staticRenderFns } from "./adv_dealBack.vue?vue&type=template&id=339283f0&viewBox=0%200%2040.173%2039"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports